export default class hover {
    constructor(manager,concept) {

        //manager
        this.manager = manager;
        this.conceptManager = concept;

    }
    init(){

        if(!(Useragnt.mobile || this.manager.isIpad)){
            // ボタンのhover動作
            for(let i in this.conceptManager.$linkList){
                if(this.conceptManager.$linkList[i].nodeType!=1) continue; // dom要素以外は処理止める
                this.conceptManager.$linkList[i].addEventListener("mouseenter",()=>{
                    this.enter(i);
                })
                this.conceptManager.$linkList[i].addEventListener("mouseleave",()=>{
                    this.leave(i);
                })
            }
        }

    }
    enter(index){

        for(let i in this.conceptManager.$linkList) {
            if (this.conceptManager.$linkList[i].nodeType != 1) continue; // dom要素以外は処理止める
            if(i == index){
                TweenMax.to(this.conceptManager.$linkList[i].querySelector('.icon'), 1.4 ,{
                    width:'120px',
                    ease: Power2.easeOut,
                });
            }else{
                TweenMax.to(this.conceptManager.$linkList[i], .8 ,{
                    opacity:.2,
                    ease: Power2.easeOut,
                });
            }
        }

    }
    leave(index){

        for(let i in this.conceptManager.$linkList) {
            if (this.conceptManager.$linkList[i].nodeType != 1) continue; // dom要素以外は処理止める
            if(i == index){
                TweenMax.to(this.conceptManager.$linkList[i].querySelector('.icon'), 1.4 ,{
                    width:'20px',
                    ease: Power2.easeOut,
                });
            }else{
                TweenMax.to(this.conceptManager.$linkList[i], .8 ,{
                    opacity:1,
                    ease: Power2.easeOut,
                });
            }
        }

    }
}